<template>
  <v-card class="pa-4">
    
    <template v-if="!snapshot">
      Select a snapshot
    </template>

    <template v-else>

      <div class="title">
        {{ snapshot.id }}
      </div>

      <!-- <div class="caption">
        {{ snapshot }}
      </div> -->

      <v-row class="align-center">
        <v-col cols="3">
          Date
        </v-col>
        <v-col cols="9">
          <c-date :date.sync="date" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
        </v-col>
      </v-row>
      <v-row class="align-center">
        <v-col cols="3">
          PriceList
        </v-col>
        <v-col cols="9">
          <c-select-price-list :selected.sync="priceLists" multiple class="crx-box-input"></c-select-price-list>
        </v-col>
      </v-row>

      <v-card class="">
        <!-- ITEM FLAGS -->
        <div style="background: #f7fafc;" class="pt-1 pb-1 pl-4 pr-4">
          <div class="subheading font-weight-bold">
            Item flags
          </div>

          <v-checkbox
          v-model="filters.item_flags.raw_material"
          label="Raw material"
          color="blue"
          ></v-checkbox>

          <v-checkbox
          v-model="filters.item_flags.product"
          label="Finished product"
          color="green"
          ></v-checkbox>

          <v-checkbox
          v-model="filters.item_flags.disposable"
          label="Disposable"
          color="red darken-3"
          ></v-checkbox>
          
          
        </div>
      </v-card>

      <v-btn v-if="eventData.current === eventData.total" @click="generate" x-large color="primary" block class="mt-2">
        GENERATE
      </v-btn>

      <div v-if="eventData.current !== eventData.total" class="text-center pa-4">

        <div class="primary--text">
          Generating...
        </div>

        <v-progress-linear
        class="ma-0"
        :value="(eventData.current / eventData.total) * 100"
        height="5"
        rounded
        ></v-progress-linear>

        <div class="caption">
          {{ eventData.current }} / {{ eventData.total }}
        </div>

    </div>

    </template>
    
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    snapshot: {
      type: Object,
      default: null
    },
    eventData: {
      type: Object,
      default: () => {
        return {
          current: 0,
          total: 0
        }
      }
    }
  },

  components: {
  },

  data () {
    return {
      priceLists: [],
      date: null,
      filters: {
        item_flags: {
          product: false,
          raw_material: false,
          disposable: false
        }
      },
      isLoading: false
    }
  },

  watch: {
    snapshot (nv) {
      var settings = Object.assign({date: null, priceLists: [], item_flags: {}}, nv.settings)
      this.date = settings.date
      this.priceLists = settings.priceLists
      this.filters.item_flags.product = settings.item_flags.product
      this.filters.item_flags.raw_material = settings.item_flags.raw_material
      this.filters.item_flags.disposable = settings.item_flags.disposable
    }
  },

  methods: {
    generate: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        var data = {
          id: this.snapshot.id,
          date: this.date,
          priceLists: this.priceLists,
          item_flags: this.filters.item_flags
        }
        this.$axios.post(`/accounting/generate-historical-stock`, data)
          .then(response => {
            this.$emit('on-generate')
            resolve()
          })
          .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
          .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true}),
  },
  created () {
  }
}
</script>